import { render, staticRenderFns } from "./auction-card.vue?vue&type=template&id=0736e9fa&scoped=true&"
import script from "./auction-card.vue?vue&type=script&lang=js&"
export * from "./auction-card.vue?vue&type=script&lang=js&"
import style0 from "./auction-card.vue?vue&type=style&index=0&id=0736e9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736e9fa",
  null
  
)

export default component.exports